import {
  filterPathIntersectionCached,
  findPathIntersection,
  findPathIntersectionCached,
  following_are_optionals,
} from "oc-app/metadata/GraphMetadata";
import * as Maths from "oc-commons/Maths";
import * as Maths2 from "oc-threejs/Maths3";
import { Vector3 } from "three";
import * as Maths3 from "oc-threejs/Maths3";
import { Jaco } from "oc-jaco3d/arrangement/Jaco";
import { ModelGhost } from "oc-jaco3d/arrangement/ModelGhost";
import { v2, v3 } from "oc-threejs/short3";
import { getMMR } from "../RichMetadata";
import { Flügel } from "./Flügel";
import { Part } from "./Part";
import {
  aussenbreiteZuFlügelbreite,
  clampTorÖffnungswinkelFürMauer,
  ElementMeta,
  elementOrTor,
  findEAntriebAuswahlwert,
  flügelbreiteZuAussenbreite,
  getAngrenzendeTeile,
  getBreiteFromFlügelBreiten,
  getElementMetaParameter,
  getElementMetasFormFüllung,
  getElementMetasGleicherForm,
  getEntferntAngrenzendeFreiraumBreiteSumme,
  getFlügelSizesV2,
  getIstZwischenabstandSumme,
  getNormaleFormVonSenkrechtFormOderSelbst,
  getProfilKategorieAuswahlwert,
  getProfilMetas,
  getSollZwischenabstandSumme,
  hasAufhängungAnPfosten,
  hasSchlossAnPfosten,
  hasSchrittweite,
  isBreiteFlügelFürEAntrieb,
  isDoppeltorFn,
  isFüllungsModelEqual,
  isGlas,
  isRhombusOderRhombusHolz,
  isSchiebetorForm,
  isTorFn,
  isTorschließerMöglichFn,
  isToröffnerMöglichFn,
  LINKS,
  positionYOf,
  RECHTS,
  Richtung,
  roundSchrittweite,
  updateSize,
  UpdateSizeParamters,
} from "./elementFunctions";
import {
  getHighestScoredMeta,
  getTargetSize,
  getWunschBreiteAussenabstand,
  matchFüllungWithHistory,
  sizeScore,
} from "./elementScoring";
import { elementHöheAmPfosten } from "./pfostenFunctions";
import { Box2, Box3, Vector2 } from "three";
import * as Commons from "oc-commons/Commons";
import { isEmpty } from "oc-commons/Commons";
import { JSON_DECIMALS } from "../commons/Utils";
import { filterElementAuswahlAccessorenForMany } from "./ElementAuswahlAccessoren";
import { Element3d } from "../arrangement3d/Element3d";
import { I18N } from "oc-I18N";
import {
  MAuswahlwert,
  MElementhalter,
  MMass,
  MModelMaterialRelation,
  MObjekt,
  MPfosten,
  MTor,
  MUMProfil,
} from "../../metamodell";
import { PAuswahlwert, PElement, PMass, PObjekt, PPfosten, PTor } from "../../metamodell_paths";
import { Pfosten } from "./Pfosten";
import { UMProfil } from "./UMProfil";
import { Eckadapter } from "./Eckadapter";
import { BestelllistenEintrag, StücklistenIterator } from "./Stückliste";
import { RahmenDef } from "../arrangement3d/schiebetor/types";

import { ausrichtungCode } from "../components/TorEigenschaften";
import { traverseSchiebetorteile, updateSchiebetor } from "./schiebetorFunctions";
import { ghostPool } from "./Arrangement";
import { schiebetorMasse } from "../arrangement3d/schiebetor/erzeugeSchiebetorRahmen";

export interface ZubehörAnzahl {
  [key: string]: number;
  "Elektrisches Bodenverriegelungs-Set"?: number;
  "Techniker Key"?: number;
  Schlüsselschalter?: number;
  "Bluetooth Schalter"?: number;
  "Connect Gateway"?: number;
  "Funk-Codeschloss"?: number;
  Handsender?: number;
  "Handsender Design"?: number;
  Lichtschranke?: number;
}

export interface FlügelÖffnungsbereichZylinderSektor {
  isAufhängungAnLinkerTorseite: boolean;
  pivot: Vector3;
  radiusInner: number;
  radiusOuter: number;
  yMin: number;
  yMax: number;
  startAngle: number;
  endAngle: number;
}

export class ZElement extends Part implements ElementMeta, UpdateSizeParamters {
  static CLASS_NAME = "Element";
  isElement = true;
  // ----------------------------------------------------------------------------------
  // persistierte Werte - Zustand, werden mit der Konfiguration gespeichert
  // ----------------------------------------------------------------------------------
  füllungAuswahlwert: MAuswahlwert = null;
  füllungAuswahlwertIndividualisiert = false;
  rahmenAuswahlwert: MAuswahlwert = null;
  gehflügelAuswahlwert: MAuswahlwert = null;
  drückerAuswahlwert: MAuswahlwert = null;
  profilzylinderAuswahlwert: MAuswahlwert = null;
  öffnungAuswahlwert: MAuswahlwert = null;
  /**
   * DIN Links / DIN Rechts - bezieht sich auf die Öffnungsrichtung und die Klobenseite
   * (Klobenseite==Anschlagsseite, nicht zu verwechseln mit Anschlagprofil und Anschlagwinkel, welche auf der anderen Seite (Schlossseite) sind),
   * wenn man in der Öffnungsrichtung vor der Tür steht, ist DIN Links Kloben auf der linke Seite und DIN Rechts=Kloben auf der rechten Seite.
   * Leider ist das alles nunmal so ;)
   */
  anschlagAuswahlwert: MAuswahlwert = null;
  schieberichtungAuswahlwert: MAuswahlwert = null;
  schiebetormotorseiteAuswahlwert: MAuswahlwert = null;
  füllungsseiteAuswahlwert: MAuswahlwert = null;
  anschlagprofilAuswahlwert: MAuswahlwert = null;
  anschlagprofilfarbeAuswahlwert: MAuswahlwert = null;
  abschlussleisteAuswahlwert: MAuswahlwert = null;
  abschlussleisteAuswahlwertIndividualisiert = false;
  profilKategorieAuswahlwert: MAuswahlwert = null;
  profilAuswahlwert: MAuswahlwert = null;
  profilAuswahlwertIndividualisiert = false;
  profilleisteAuswahlwert: MAuswahlwert = null;
  eAntriebAuswahlwert: MAuswahlwert = null;
  aufsatzleisteAuswahlwert: MAuswahlwert = null;
  toröffnerAuswahlwert: MAuswahlwert = null;
  torschließerAuswahlwert: MAuswahlwert = null;
  form: MObjekt = null;
  profilPosition: number | "center" | null = null;
  profilPositionIndividualisiert = false;
  showProfil: boolean | null = null;
  size = v3();
  anschlussAufRechts = false;
  // beim Doppeltor ist die Breite==size.x die Summe der Flügel + 0.04
  // die Standflügelbreite ist abgeleitet, nur die Breite und die gehflügelbreite werden persistiert
  gehflügelbreite = 0;
  standflügelbreite = 0;
  torIstFertig = false;
  // Zubehör für Tore mit E-Antrieb (generisch für Doppeltor + Schiebetor)
  zubehörAnzahl: ZubehörAnzahl = {
    "Elektrisches Bodenverriegelungs-Set": 0,
    "Techniker Key": 0,
    Schlüsselschalter: 0,
    "Bluetooth Schalter": 0,
    "Connect Gateway": 0,
    "Funk-Codeschloss": 0,
    Handsender: 0,
    "Handsender Design": 0,
    Lichtschranke: 0,
  };

  /** eine nur zum Testen selten benutzte ID für Persistierungstests **/
  elementID = 0;
  /** ist das Element individualisiert (gelockt?) */
  showIndividualisiert = false;

  // ----------------------------------------------------------------------------------
  // session Werte - Zustand, werden beim App-Neustart zurückgesetzt
  // ----------------------------------------------------------------------------------
  torÖffnungswinkel = 10;
  hovered = false;
  schiebetorOffen = false;
  // ----------------------------------------------------------------------------------
  // abgeleitete Werte - d.h. sind letztlich nur berechnet (in update3d) und gecached, kein Zustand
  // Achtung, diese Werte muss man immer ganz besonders im Auge haben, kann sein,
  // dass sie fälschlich doch als Zustand dienen, und das führt dann zu schwierigen Bugs
  // ----------------------------------------------------------------------------------
  flügel: Flügel[] = [];
  elementhalter: ModelGhost[] = [];
  pfostenRechts: Pfosten | null = null;
  pfostenLinks: Pfosten | null = null;
  umprofilRechts: UMProfil | null = null;
  umprofilLinks: UMProfil | null = null;
  eckadapterRechts: Eckadapter | null = null;
  eckadapterLinks: Eckadapter | null = null;
  bestellliste: BestelllistenEintrag[] = [];
  gesamtpreis = 0;
  // gecachte Werte, die gecloned werden müssen
  meta: MTor;
  füllungMeta: MObjekt;
  profilMeta: MObjekt;
  rahmenMeta: MObjekt = null;
  massMetas: MMass[] = [];
  massAuswahlwert: MAuswahlwert;
  // union der MinMax bzw. Standard-Größen aller zur Form möglichen Element-Maße
  // Im Falle von Doppeltoren bezieht sich sizeRange auf die einzelnen Flügel, nicht auf die gesamt-Size
  sizeRange = {
    Schrittweite: v2(),
    box: new Box2(),
    flügelBox: new Box2(),
  };
  isStandardMass = false;
  hideTag = false;
  positionY = 0;
  verringerterBodenabstand = 0;
  schiebetorRahmenDef: RahmenDef = null;
  schiebetorFixPunkt: Jaco = new Jaco(this);
  schiebetorTranslationsPunkt: Jaco = new Jaco(this.schiebetorFixPunkt);

  // ----------------------------------------------------------------------------------
  constructor(parent) {
    super(parent);
    this.reset();
  }

  traverse(iterator: (jaco: Jaco) => void) {
    super.traverse(iterator);
    if (this.flügel) this.flügel.forEach((o) => o.traverse(iterator));
    if (this.elementhalter) this.elementhalter.forEach((o) => o.traverse(iterator));
    traverseSchiebetorteile(this, iterator);
  }

  update3d() {
    if (this.form == null) {
      debugger;
    }
    super.update3d();
    updateSchiebetor(this);
    this.elementhalter = ghostPool(this).clearInstances(this.elementhalter);
    this.updateInner();
    this.updateElementhalter();
    // this.maybeShowDebugObjects();
  }

  updateInner() {
    this.updateMetaAndSize();
    if (this.meta == null) {
      console.error("dem Element ist keine Meta zugeordnet", this.meta);
      debugger;
      return;
    }
    if (this.füllungMeta == null) {
      console.error("dem Element ist keine Füllung zugeordnet", this.meta);
      return;
    }
    if (!this.arrangement.nurMasseUpdaten) {
      if (this.isSchiebetor) {
        this.updateFlügelSchiebetor();
      } else {
        this.updateFlügelNormal();
      }
    }
  }

  updateMetaAndSize() {
    this.updateMetas();
    this.position.y = this.positionY;
    this.updateSize();
  }

  updateElementhalter() {
    // jeweils für den pfosten links und rechts
    [true, false].flatMap((istLinks) => {
      const pfosten = istLinks ? this.pfostenLinks : this.pfostenRechts;
      const elementhalterMeta = this.getElementhalterFürPfosten(pfosten);
      if (elementhalterMeta == null) {
        return;
      }
      const { DeltaKanteX, DeltaKanteY, DeltaKanteZ, Zentriert, FixKantenY } = elementhalterMeta;
      // ermittle die Anzahl und y-Positionen der Elementhalter
      let halterYList = (() => {
        const höhe = elementHöheAmPfosten(pfosten, this, istLinks, false);
        const anzahlElementHalter = Math.max(
          elementhalterMeta.MinElementhalter,
          Math.floor(höhe / elementhalterMeta.MeterProElementhalter)
        );
        if (Commons.isEmpty(FixKantenY)) {
          let halterYList = [];
          const deltaKanteY = DeltaKanteY;
          const unteresY = deltaKanteY;
          const oberesY = höhe - deltaKanteY - this.positionY * 1.5;
          halterYList.push(unteresY);
          const zusätzlicheAnzahl = anzahlElementHalter - 2;
          if (zusätzlicheAnzahl > 0) {
            const dy = (oberesY - unteresY) / (zusätzlicheAnzahl + 1);
            for (let i = 0; i < zusätzlicheAnzahl; i++) {
              halterYList.push(halterYList[i] + dy);
            }
          }
          halterYList.push(oberesY);
          return halterYList;
        } else {
          // Benutze FixKantenY wenn definiert
          return FixKantenY.toArray().slice(0, anzahlElementHalter);
        }
      })();
      // falls es horizontale Querleisten gibt, platziere die Elementhalter daran
      (() => {
        const querleisten = this.flügel[0]?.querleisten;
        if (querleisten?.length > 0) {
          const querleistenYList = querleisten.flatMap((querleiste) =>
            querleiste.modelle
              .filter((modell) => (modell as any).isHorizontal)
              .map((modell) => modell.position.y - 0.02)
          );
          halterYList = querleistenYList;
        }
      })();
      // erzeuge die Elementhalter-Modelle
      (() => {
        const mmr = elementhalterMeta.ModelMaterialRelation[0];
        const isJumboAndAnschlussRechts = this.isJumboWPC && this.anschlussAufRechts;
        const isAros = this.isAros;
        const box = this.getBox();
        halterYList.forEach((y) => {
          const teil = ghostPool(this).getForModelMaterialRelation(this, mmr, {
            size: v3(Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY),
            fixGridPosition: v3(0, 0, 0),
            gehrung45: false,
          });
          const x = istLinks ? -0.001 + DeltaKanteX : this.size.x + 0.001 - DeltaKanteX;
          const zPosition = Zentriert ? 0 : box.min.z;
          const z =
            (this.seiteGewechselt ? -1 : 1) *
            (zPosition + DeltaKanteZ + (isJumboAndAnschlussRechts ? -0.01 : 0));
          teil.position.set(x, y, z);
          teil.scale.x = istLinks ? -1 : 1;
          teil.scale.z = this.seiteGewechselt ? -1 : 1;
          if (isAros) {
            // Aros Elementhalter werden unter die Querleisten montiert, daher 90° gedreht
            teil.quaternion.setFromAxisAngle(v3(1, 0, 0), Math.PI / 2);
          }
          this.elementhalter.push(teil);
        });
      })();
    });
    this.elementhalter.forEach((e) => e.update3d());
  }

  getElementhalterFürPfosten(pfosten: Pfosten) {
    return findPathIntersectionCached("Element.js:272")(
      pfosten?.elementhalterAuswahlwert,
      (p: PAuswahlwert) => p.Elementhalter,
      this.meta,
      (p: PTor) => p.Elementhalter
    ) as MElementhalter;
  }

  getBeschlagsatzFürTor(pfosten: Pfosten) {
    return findPathIntersectionCached("Element.js:272")(
      pfosten?.meta,
      (p: PPfosten) => p.Beschlagsatz,
      this.meta,
      (p: PTor) => p.Beschlagsatz
    ) as MObjekt;
  }

  updateMetas() {
    const {
      massMetas,
      sizeRange,
      isBreiteKonfigurierbar,
      meta,
      positionY,
      füllungMeta,
      füllungAuswahlwert,
      profilKategorieAuswahlwert,
      profilMeta,
      showProfil,
      profilAuswahlwert,
      profilleisteAuswahlwert,
      rahmenAuswahlwert,
      rahmenMeta,
      abschlussleisteAuswahlwert,
      eAntriebAuswahlwert,
      profilzylinderAuswahlwert,
      drückerAuswahlwert,
      öffnungAuswahlwert,
      aufsatzleisteAuswahlwert,
      massAuswahlwert,
      toröffnerAuswahlwert,
      torschließerAuswahlwert,
      verringerterBodenabstand,
      schiebetorRahmenDef,
    } = getElementMetaParameter(this);
    this.massMetas = massMetas;
    this.sizeRange = sizeRange;
    this.schiebetorRahmenDef = schiebetorRahmenDef;
    this.isBreiteKonfigurierbar = isBreiteKonfigurierbar;
    this.meta = meta as any;
    this.positionY = positionY;
    this.füllungMeta = füllungMeta;
    this.füllungAuswahlwert = füllungAuswahlwert;
    this.profilMeta = profilMeta;
    this.showProfil = showProfil;
    this.profilKategorieAuswahlwert = profilKategorieAuswahlwert;
    this.profilAuswahlwert = profilAuswahlwert;
    // profilPosition nur setzen, wenn sie noch nicht explizit gesetzt wurde
    if (this.profilPosition == null) {
      this.profilPosition = this.arrangement?.profilPosition_ ?? this.sonderprofilPosition;
    }
    this.profilleisteAuswahlwert = profilleisteAuswahlwert;
    this.rahmenAuswahlwert = rahmenAuswahlwert;
    this.rahmenMeta = rahmenMeta;
    this.abschlussleisteAuswahlwert = abschlussleisteAuswahlwert;
    this.eAntriebAuswahlwert = eAntriebAuswahlwert;
    this.profilzylinderAuswahlwert = profilzylinderAuswahlwert;
    this.drückerAuswahlwert = drückerAuswahlwert;
    this.öffnungAuswahlwert = öffnungAuswahlwert;
    this.aufsatzleisteAuswahlwert = aufsatzleisteAuswahlwert;
    this.massAuswahlwert = massAuswahlwert;
    this.toröffnerAuswahlwert = toröffnerAuswahlwert;
    this.torschließerAuswahlwert = torschließerAuswahlwert;
    this.verringerterBodenabstand = verringerterBodenabstand;
  }

  change({
    massAuswahlwert,
    füllungAuswahlwert,
    size,
    seiteGewechselt,
    profilAuswahlwert,
    individualisiert = false,
    maximalBreite,
    elementPreview = false,
    form,
  }: Partial<{
    massAuswahlwert: MAuswahlwert;
    füllungAuswahlwert: MAuswahlwert;
    size: Vector2;
    seiteGewechselt: boolean;
    profilAuswahlwert: MAuswahlwert;
    individualisiert: boolean;
    maximalBreite: number;
    elementPreview: boolean;
    form: MAuswahlwert;
  }>) {
    this.hideTag = elementPreview;
    const setMetaAndSize = (meta, size) => {
      this.meta = meta;
      this.form = meta.Mass.Form;
      this.massAuswahlwert = this.meta?.Mass?.EasyAuswahlwert;
      if (this.isSchiebetor) {
        this.breite = size.x;
      } else {
        const flügelbreite = aussenbreiteZuFlügelbreite(isDoppeltorFn(meta), size.x);
        this.getFlügelSizesV2().forEach((_, i) => {
          this.setFlügelBreite(flügelbreite, i);
        });
      }
      this.size.y = this.höhe = size.y;
      this.updateMetas();
      this.updateSize();
    };

    // Nimmstandardbreite=true wenn zu viel Platz ist um die Lücke voll zu füllen,
    // nimmStandardbreite=false wenn die Lücke füllbar ist
    const isNimmStandardbreite = (massMetas: MMass[]) => {
      const maxXFlügel = _.max(massMetas.map((mass) => mass.MinMaxX?.y ?? mass.Standard.x));
      const maxX = flügelbreiteZuAussenbreite(
        massMetas.some((m) => m?.Tor?.some((t) => t?.Doppeltor)),
        maxXFlügel
      );
      return maxX < maximalBreite;
    };

    if (maximalBreite == null && this.segment?.isSegment) {
      maximalBreite = getEntferntAngrenzendeFreiraumBreiteSumme(this) + this.breite;
    }

    if (seiteGewechselt) {
      this.seiteGewechselt = seiteGewechselt;
    }
    if (profilAuswahlwert) {
      if (
        individualisiert ||
        !this.profilAuswahlwertIndividualisiert ||
        this.arrangement.isAllPartsIndividualisiert(
          this.arrangement.getElemente(),
          "profilAuswahlwertIndividualisiert"
        )
      ) {
        this.profilAuswahlwert = profilAuswahlwert;
        if (individualisiert) {
          this.profilAuswahlwertIndividualisiert =
            this.profilAuswahlwert != this.arrangement.profilAuswahlwert_;
        }
      }
    } else {
      if (massAuswahlwert) {
        // der Maßauswahlwert hat zwei Aspekte: 1. Form, 2. Size
        const form = findPathIntersectionCached("Element.js:378")(
          massAuswahlwert,
          (p: PAuswahlwert) => p.Mass.Form
        ) as MObjekt;

        const elementeDerSerieGleicherForm = getElementMetasGleicherForm(form);
        const serieMassMetas = filterPathIntersectionCached("Element.js:381")(
          elementeDerSerieGleicherForm,
          (p: PTor) => p.Mass
        ) as MMass[];
        const standardMassMetas = filterPathIntersectionCached("Element.js:382")(
          massAuswahlwert,
          (p: PAuswahlwert) => p.Mass,
          serieMassMetas,
          (p: PMass) => p,
          following_are_optionals,
          füllungAuswahlwert ?? this.füllungAuswahlwert,
          (p: PAuswahlwert) => elementOrTor(p.Füllung_Objekt).Mass
        ) as MMass[];

        const nimmStandardBreite = isNimmStandardbreite(standardMassMetas) || size != null;
        const nichtFertigungsMasse = standardMassMetas.filter((m) => m.Variabel != "fertigung");
        const breiteDarfSichAnpassen = standardMassMetas.length > 0;

        // "Aussenabstand" ist immer von Nachbar-Element-Kante|Segmentende|Mauer von Seite zu Seite, ohne Pfosten
        const standardMasse =
          nichtFertigungsMasse.length > 0 ? nichtFertigungsMasse : standardMassMetas;
        const maxStandardSize = _.maxBy(standardMasse, (m) => m.Standard.x).Standard;
        const istZwischenabstand = getIstZwischenabstandSumme(this);

        const getWunschBreiteAussenabstandUndHöhe = (elementMeta) => {
          const { x, y } =
            size ??
            (() => {
              const standard = standardMasse.includes(elementMeta.Mass)
                ? elementMeta.Mass.Standard
                : maxStandardSize;
              if (
                standard != null &&
                maximalBreite != null &&
                breiteDarfSichAnpassen &&
                !nimmStandardBreite
              ) {
                return v2(maximalBreite, standard.y);
              }
              const aussenbreite = flügelbreiteZuAussenbreite(
                isDoppeltorFn(elementMeta),
                standard.x
              );
              return v2(aussenbreite, standard.y);
            })();
          return v2(getWunschBreiteAussenabstand(x, nimmStandardBreite, istZwischenabstand), y);
        };

        const sollZwischenabstand = (elementMeta, wunschbreite = undefined) =>
          nimmStandardBreite ? 0 : getSollZwischenabstandSumme(this, elementMeta, wunschbreite);
        const sizeScoreMeta = (elementMeta) =>
          sizeScore(
            elementMeta,
            getWunschBreiteAussenabstandUndHöhe(elementMeta),
            sollZwischenabstand(elementMeta)
          );
        const füllungScoreMeta = (elementMeta) =>
          matchFüllungWithHistory(
            elementMeta,
            füllungAuswahlwert ?? this.füllungAuswahlwert,
            this.arrangement.füllungAuswahlwertHistory
          );
        const massAuswahlwertScoreMeta = (elementMeta) =>
          elementMeta.Mass.EasyAuswahlwert.Key === massAuswahlwert.Key ? 0 : -1;

        const scoreEAntrieb = (meta) => {
          const wunschBreiteUndHöhe = getWunschBreiteAussenabstandUndHöhe(meta);
          const zwischenabstand = sollZwischenabstand(meta, wunschBreiteUndHöhe.x);
          const size = getTargetSize(
            meta,
            nimmStandardBreite,
            zwischenabstand,
            wunschBreiteUndHöhe
          );
          const flügelbreite = aussenbreiteZuFlügelbreite(
            isDoppeltorFn(meta),
            wunschBreiteUndHöhe.x,
            zwischenabstand
          );
          const flügelSizes = getFlügelSizesV2({
            isDoppeltor: isDoppeltorFn(meta),
            isGehflügelLinks: this.isGehflügelLinks,
            standflügelbreite: flügelbreite,
            gehflügelbreite: flügelbreite,
            size,
          });
          const eAntriebAuswahlwert = findEAntriebAuswahlwert(
            meta,
            flügelSizes,
            this.eAntriebAuswahlwert
          );
          const isEAntrieb = eAntriebAuswahlwert?.Key === "E_Antrieb_mit";
          return meta.E_Antrieb_Vorhanden === isEAntrieb ? 0 : -0.14;
        };

        // Das hier ist nur eine Teilmenge vom Scoring aus findBestMatchingElementMeta,
        // sollte aber für den Zweck der Maßfindung möglichst gleich sein.
        // Abweichungen können zu kniffligen Maß-Bugs führen, wie bei Doppeltor-E_Antrieb_Vorhanden,
        // weil bei solchen Bugs im Change das falsche Meta ausgewählt aber direkt danach
        // im folgenden update korrigiert wird - dann allerdings mit abweichenden Gesamtmassen.
        const score = (elementMeta) =>
          sizeScoreMeta(elementMeta) +
          füllungScoreMeta(elementMeta).score * (elementPreview ? 0.01 : 1) +
          massAuswahlwertScoreMeta(elementMeta) +
          scoreEAntrieb(elementMeta);

        const winnerMeta = getHighestScoredMeta(elementeDerSerieGleicherForm, score);

        const wunschBreiteUndHöhe = getWunschBreiteAussenabstandUndHöhe(winnerMeta);
        const sollZwischenAbstand = sollZwischenabstand(winnerMeta, wunschBreiteUndHöhe.x);

        const targetSize = getTargetSize(
          winnerMeta,
          nimmStandardBreite,
          sollZwischenAbstand,
          wunschBreiteUndHöhe
        );

        // wichtig: Auswahlwerte erst hier am Ende setzen, da es sonst teilweise Seiteneffekte gibt
        this.füllungAuswahlwert = füllungScoreMeta(winnerMeta).füllungAuswahlwert;
        setMetaAndSize(winnerMeta, targetSize);
      } else if (füllungAuswahlwert) {
        if (
          individualisiert ||
          !this.füllungAuswahlwertIndividualisiert ||
          this.arrangement.isAllPartsIndividualisiert(
            this.arrangement.getElemente(),
            "füllungAuswahlwertIndividualisiert"
          )
        ) {
          let formFürMatching = this.form ?? form ?? APP.richMetadata.findForm("Rechteck");

          // es kann sein, dass durch die Füllung ein anderes Mass gleicher Form notwendig wird
          let elementMetasFormFüllung = getElementMetasFormFüllung(
            getElementMetasGleicherForm(formFürMatching),
            füllungAuswahlwert
          );

          // Falls Senkrecht-Form vorliegt und nichts passendes gefunden wird: Suche nochmal mit normaler Form
          if (isEmpty(elementMetasFormFüllung)) {
            formFürMatching = getNormaleFormVonSenkrechtFormOderSelbst(formFürMatching);
            elementMetasFormFüllung = getElementMetasFormFüllung(
              getElementMetasGleicherForm(formFürMatching),
              füllungAuswahlwert
            );
          }

          // wir ändern nur was, wenn die Füllung möglich ist, sonst nix
          if (elementMetasFormFüllung.length > 0) {
            // alles weitere bestimmt das am besten passende Maß
            // die Size sollte Lücken füllen. Falls genug Platz ist, sollte das Standardmaß gewählt werden,
            // was am ehesten der aktuellen Größe entspricht.
            // Falls nicht genug Platz ist, eines, das halt reinpasst

            // elementBreiteIstFix==false bewirkt, dass die WunschBreiteAussenabstand
            // (letztlich der Zwischenabstand) bei allen Maßen angerechnet wird, egal ob
            // Fix oder Maßelement. Da wir die Füllung und nicht das Maß vorgeben, ist uns
            // das Einhalten der Abstände wichtig, egal ob es ein Fix- oder Maßelement ist.
            // Dadurch wird ein Bug behoben: testRomoRundbogenKlickAufSelbeFüllung
            const elementBreiteIstFix = false;

            // "Aussenabstand" ist immer von Nachbar-Element-Kante|Segmentende|Mauer von Seite zu Seite, ohne Pfosten
            // TODO es sollte einen Schwellwert geben, also ein Breitenintervall um wunschBreiteAussenabstand,
            // innerhalb dessen sich das Element beim Füllungswechsel einpasst
            const wunschBreiteAussenabstandUndHöhe = (() => {
              const { x, y } = size ?? this.size;
              const istZwischenabstand = getIstZwischenabstandSumme(this);
              return v2(
                getWunschBreiteAussenabstand(x, elementBreiteIstFix, istZwischenabstand),
                y
              );
            })();

            const score = (elementMeta) =>
              sizeScore(
                elementMeta,
                wunschBreiteAussenabstandUndHöhe,
                getSollZwischenabstandSumme(this, elementMeta)
              );

            const winnerMeta = getHighestScoredMeta(elementMetasFormFüllung, score);

            const targetSize = getTargetSize(
              winnerMeta,
              elementBreiteIstFix,
              getSollZwischenabstandSumme(this, winnerMeta),
              wunschBreiteAussenabstandUndHöhe
            );

            // wichtig: Auswahlwerte erst hier am Ende setzen, da es sonst teilweise Seiteneffekte gibt
            this.füllungAuswahlwert = füllungAuswahlwert;
            setMetaAndSize(winnerMeta, targetSize);
          }
          if (individualisiert) {
            this.füllungAuswahlwertIndividualisiert =
              this.füllungAuswahlwert != this.arrangement.füllungAuswahlwertHistory[0];
          }
        }
      } else {
        debugger;
      }
    }
  }

  addLichtleiste() {
    const lichtleistenAuswahlwerte = this.profilAuswahlwert.Auswahl.Auswahlwert.filter((a) =>
      a.Key.match(/licht/i)
    );
    const newProfileAuswahlwert = this.isRhombusOderRhombusHolz
      ? lichtleistenAuswahlwerte.find((a) => a.Key.match(/rhombus/i))
      : lichtleistenAuswahlwerte.find((a) => !a.Key.match(/rhombus/i));
    this.profilAuswahlwert = newProfileAuswahlwert;
  }

  dump() {
    console.log("--------------");
    console.log("mögliche Maße: ", this.massMetas.map((m) => m.Key).join(", "));
    console.log("size", this.size + "");
    console.log("sizeRange", this.sizeRange);
    console.log("massAuswahlwert: ", this.massAuswahlwert);
    console.log("form: ", this.form);
  }

  get torMaxBreiteInfo() {
    if (this.isTor) {
      const pfosten = this.getPfosten().filter((p) => p != null);
      if (pfosten.length > 0 && pfosten.some((p) => p.anMauer)) {
        return {
          breite: APP.settings.MaximalbreiteTorAnMauer,
          hinweisI18NKey: "max. Flügelbreite %s m da Mauern",
        };
      }
      if (pfosten.some((p) => p.isAufgeschraubt)) {
        return {
          breite: APP.settings.MaximalbreitePfostenAufgeschraubt,
          hinweisI18NKey: "max. Flügelbreite %s m da Pfosten aufgeschraubt",
        };
      }
    }
    return null;
  }

  get torMaxBreite() {
    return this.torMaxBreiteInfo?.breite ?? Number.POSITIVE_INFINITY;
  }

  updateSize() {
    const { breite, size, isStandardMass, massAuswahlwert, gehflügelbreite, standflügelbreite } =
      updateSize(this);
    this.breite = breite;
    this.size = size;
    this.isStandardMass = isStandardMass;
    this.massAuswahlwert = massAuswahlwert;
    this.gehflügelbreite = gehflügelbreite;
    this.standflügelbreite = standflügelbreite;
  }

  hasSchrittweite(axis) {
    return hasSchrittweite(axis, this.sizeRange.Schrittweite);
  }

  roundSchrittweite(axis, axisValue) {
    const { flügelBox, Schrittweite } = this.sizeRange;
    return roundSchrittweite(axis, axisValue, flügelBox, Schrittweite);
  }

  getSchrittweitenOptionen(axis) {
    if (!this.hasSchrittweite(axis)) {
      return;
    }
    const { flügelBox, Schrittweite } = this.sizeRange;
    const epsilon = 0.001;
    const schrittweite = Schrittweite?.[axis];
    const min = flügelBox.min[axis];
    const max = flügelBox.max[axis];
    let optionen = [];
    for (let i = 0; i < 100; i++) {
      const rounded = Maths.round(min + i * schrittweite, 3);
      if (rounded > max + epsilon) {
        break;
      }
      optionen.push(rounded);
    }
    optionen = optionen.reverse();
    return optionen;
  }

  getLeisten() {
    const profilKategorie = this.profilKategorie;
    const findAbschlussleiste = (leisten: MObjekt[]) =>
      findPathIntersectionCached("Element.js:595")(
        leisten,
        (leiste: PObjekt) => leiste,
        this.abschlussleisteAuswahlwert,
        (auswahlwert: PAuswahlwert) => auswahlwert.Objekt
      ) as MObjekt;
    const findProfilLeiste = (leisten) =>
      !profilKategorie?.ProfilleisteNichtFürDekorprofile
        ? (findPathIntersectionCached("Element.js:603")(
            leisten,
            (leiste: PObjekt) => leiste,
            this.profilleisteAuswahlwert,
            (auswahlwert: PAuswahlwert) => auswahlwert.Objekt
          ) as MObjekt)
        : null;
    const findAufsatzleiste = (leisten) =>
      findPathIntersectionCached("Element.js:611")(
        leisten,
        (leiste: PObjekt) => leiste,
        this.aufsatzleisteAuswahlwert,
        (auswahlwert: PAuswahlwert) => auswahlwert.Objekt
      ) as MObjekt;
    return _.mapValues(
      {
        unten: findAbschlussleiste(this.meta.AbschlussleisteUnten),
        zwischen:
          profilKategorie?.ProfilleisteAlsZwischenleiste && _.first(profilKategorie?.Profilleiste),
        oben: findAbschlussleiste(this.meta.AbschlussleisteOben),
        dekorprofilleisteUnten: findProfilLeiste(this.sonderprofilKategorie?.Profilleiste),
        dekorprofilleisteOben:
          this.isSenkrechtprofile ===
          this.sonderprofilKategorie?.ProfilleisteObenNurFürSenkrechtprofile
            ? findProfilLeiste(this.sonderprofilKategorie?.ProfilleisteOben)
            : null,
        uAbschlussprofil: _.first(profilKategorie?.UAbschlussprofil),
        aufsatzleiste: findAufsatzleiste(this.meta.Aufsatzleiste),
      },
      (x) => this.teilInfo(x)
    );
  }

  teilInfo(meta: any) {
    if (!meta || !meta?.ModelMaterialRelation) {
      return null;
    }
    const modelMaterialRelation = getMMR(meta);
    const modelSize = this.getBoundingBoxForMeta(modelMaterialRelation);
    return { meta, modelMaterialRelation, modelSize };
  }

  getBoundingBoxForMeta(meta: any) {
    return APP.modelsHelper.getBoundingBox(meta).getSize(v3());
  }

  setShowProfil(showProfil: boolean) {
    this.showProfil = showProfil;
    if (showProfil) {
      this.profilKategorieAuswahlwert = getProfilKategorieAuswahlwert(this);
      const profilMetas = getProfilMetas(this);
      this.profilAuswahlwert = (
        isFüllungsModelEqual(profilMetas[0]?.Auswahlwert, this.füllungAuswahlwert)
          ? profilMetas[1]
          : profilMetas[0]
      )?.Auswahlwert;
    }
  }

  get profilKategorie() {
    const profilkategorien = this.meta?.Profilkategorie ?? [];
    return (
      profilkategorien.find((p) => p.Profile?.includes(this.füllungMeta)) ??
      _.first(profilkategorien)
    );
  }

  get sonderprofilKategorie() {
    const profilkategorien = this.meta?.Profilkategorie ?? [];
    return profilkategorien.find((p) => p.Profile?.includes(this.profilMeta));
  }

  // Fixme: Umschreiben, wenn Dekorprofile eigene Masstabelle haben
  get sonderprofilMinMax() {
    const profilKategorie =
      this.profilKategorieAuswahlwert?.Profilkategorie?.[0] ?? this.sonderprofilKategorie;
    const leisten = this.getLeisten();
    let ProfilAnzahl, Mindesthöhe, ObenErlaubt, Profilleiste;
    if (profilKategorie) {
      ({ ProfilAnzahl, Mindesthöhe, ObenErlaubt, Profilleiste } = profilKategorie);
    }
    const höheMitAbstand = (
      m:
        | {
            modelSize: Vector3;
            modelMaterialRelation?: MModelMaterialRelation;
          }
        | undefined
    ) => (m ? m.modelSize.y + (m.modelMaterialRelation?.Model?.Profilabstand ?? 0) : 0);

    // Frag' nicht warum - die ganze Rechnerei hier ist magic...
    const zwischenLeiste = höheMitAbstand(!this.isRhombusOderRhombusHolz && leisten.zwischen) * 0.5;
    // ... das hier wäre eigentlich auch noch relevant
    const obereUntereLeisten =
      höheMitAbstand(leisten.unten) * 0.5 + höheMitAbstand(leisten.oben) * 0.5;
    // .. aber so laufen die Tests erstmal durch!

    const profilInfo = this.teilInfo(this.füllungMeta);
    const profilAbstandPlain = profilInfo.modelMaterialRelation.Model.Profilabstand ?? 0;
    const profilAbstand = profilAbstandPlain + zwischenLeiste;

    const profilHöhe = profilInfo?.modelSize.y;
    const dekorprofilEinzelprofilHöhe = this.teilInfo(this.profilMeta)?.modelSize.y;
    const dekorprofilHöhe =
      ProfilAnzahl > 1
        ? (dekorprofilEinzelprofilHöhe + profilAbstand) * ProfilAnzahl - profilAbstand
        : dekorprofilEinzelprofilHöhe;
    let gesamtHöhe =
      (this.isSenkrechtprofile
        ? Math.min(...this.flügel.map((f: Flügel) => f.füllung.size.x))
        : this.size.y) + 0.001; // 1mm extra für Rundungsfehler
    if (this.isSchiebetor) {
      gesamtHöhe -= this.getRahmenInnenabstand();
    }
    const profilHöheMitProfilabstand = profilHöhe + profilAbstand;
    const wegschneidenData = this.getWegschneidenHöheUnterstesProfil();
    let wegschneidenHöheUnterstesProfil = wegschneidenData.offsetY;
    if (this.isSenkrechtprofile) {
      let platzZuFüllen = gesamtHöhe;
      if (this.showProfil) {
        const { dekorprofilleisteOben, dekorprofilleisteUnten } = leisten;
        platzZuFüllen -=
          dekorprofilHöhe +
          profilAbstandPlain +
          höheMitAbstand(dekorprofilleisteOben) +
          höheMitAbstand(dekorprofilleisteUnten);
      }
      let anzahlNormaleProfile = Math.ceil(platzZuFüllen / (profilHöhe + profilAbstandPlain));
      const platzNormaleProfile =
        anzahlNormaleProfile * profilHöhe + (anzahlNormaleProfile - 1) * profilAbstandPlain;
      const rest = platzNormaleProfile - platzZuFüllen;
      wegschneidenHöheUnterstesProfil = rest / 2 + profilAbstandPlain;
    }
    const profilAnzahl = Math.max(
      1,
      Math.floor(
        (gesamtHöhe -
          obereUntereLeisten -
          (!this.isRhombusOderRhombusHolz
            ? profilHöhe - wegschneidenHöheUnterstesProfil * (this.isSenkrechtprofile ? 2 : 1)
            : 0) -
          Math.max(0, dekorprofilHöhe - profilHöhe) +
          profilAbstand) /
          profilHöheMitProfilabstand
      ) + (!this.isRhombusOderRhombusHolz ? (wegschneidenHöheUnterstesProfil > 0 ? 1 : 0) : 0)
    );
    const fixedPosition =
      Math.max(1, Math.floor((gesamtHöhe + profilAbstand) / profilHöheMitProfilabstand)) *
      Mindesthöhe;
    const höheOberstesProfil = this.isSenkrechtprofile
      ? profilHöhe - wegschneidenHöheUnterstesProfil
      : gesamtHöhe % (profilHöhe + profilAbstand);
    const epsilon = this.isTor ? 0.11 : 0.04;
    const isLichtleiste = this.profilMeta?.Key.startsWith("SYSTEM_Lichtleiste_Rhombus");
    const maxPosition =
      profilAnzahl -
      (ObenErlaubt || this.isSchiebetor ? 0 : 1) +
      (!this.isTor && dekorprofilHöhe < 0.1 ? 1 : 0) +
      (dekorprofilHöhe < 0.1 ? 1 : 0) +
      /*this.isRhombusOderRhombusHolz &&*/ (!this.isTor && profilHöhe > 0.1 && dekorprofilHöhe > 0.1
        ? 1
        : 0) +
      (this.isTor && dekorprofilHöhe < 0.16 && dekorprofilHöhe > 0.1 && profilHöhe > 0.16 ? 1 : 0) +
      (!this.isTor && this.isRhombusOderRhombusHolz && Profilleiste != null ? 1 : 0) +
      (this.isTor && this.isRhombusOderRhombusHolz ? -1 : 0) +
      (this.isSenkrechtprofile && höheOberstesProfil > epsilon ? 1 : 0) +
      /*this.isRhombusOderRhombusHolz &&*/ (fixedPosition > 0 ? -2 : 0) +
      (isLichtleiste ? -3 : 0) + // Quickfix bis zum Refactoring
      (isLichtleiste && ObenErlaubt ? 2 : 0) +
      (isLichtleiste && this.isRhombusNichtHolz ? -1 : 0);
    // Wenn ObenErlaubt ist, dann ist auch unten erlaubt
    let minPosition = fixedPosition > 0 ? maxPosition - 1 : ObenErlaubt ? 0 : 1;
    // Bei Toren: profilPositionDelta = Anzahl komplett hinter dem Rahmen versteckter Profile,
    // offsetY > 0 = das nächste Profil wird zugeschnitten → auch ungültig für Dekorprofil
    if (this.isTor && fixedPosition <= 0) {
      const cutOffset = wegschneidenData.offsetY > 0.001 ? 1 : 0;
      minPosition = Math.max(minPosition, wegschneidenData.profilPositionDelta + cutOffset);
    }

    const dekorprofilErlaubt =
      !this.showProfil || ObenErlaubt || gesamtHöhe / profilHöheMitProfilabstand > 2.2;

    return {
      minPosition,
      maxPosition,
      mindesthöhe: Mindesthöhe,
      fixedPosition,
      profilAnzahl: ProfilAnzahl ?? 1,
      gesamtHöhe,
      dekorprofilErlaubt,
    };
  }

  get sonderprofilPosition() {
    if (this.profilPosition == "center") return this.profilPosition;

    const { minPosition, maxPosition } = this.sonderprofilMinMax;
    const pos = Number.isNaN(this.profilPosition) ? maxPosition : this.profilPosition;
    const profilPosition = _.clamp(pos ?? maxPosition, minPosition + 1, maxPosition);
    return profilPosition;
  }

  // wird relativ direkt vom UI aufgerufen
  setKonfigurierbareBreite(breite) {
    if (breite < 0.01) {
      this.breite = breite;
      this.uiRemove();
      return;
    }
    this.segment.setVerteilungsmodusIndividuell();
    this.setBreite(breite);
    this.segment.repositionAndCheckSnaps();
  }

  // wird eher intern aufgerufen
  setBreite(breite) {
    if (this.isDoppeltor) {
      if (
        typeof this.breite === "number" &&
        Number(this.breite.toFixed(2)) === Number(breite.toFixed(2))
      ) {
        return;
      }
      // die Breite ist die Gesamtbreite. Es wird versucht, die Breite auf die Flügel aufzuteilen,
      // so dass die Flügelbreite möglichst gleich ist.
      const flügelBreite = this.roundSchrittweite("x", aussenbreiteZuFlügelbreite(true, breite));
      [0, 1].forEach((i) => this.setFlügelBreite(flügelBreite, i));
    } else {
      this.breite = this.roundSchrittweite("x", breite);
    }
  }

  setKonfigurierbareHöhe(höhe: number) {
    this.höhe = this.roundSchrittweite("y", höhe);
  }

  updateFlügelNormal() {
    const flügelPool = this.lazyPool(
      this.flügel,
      () => new Flügel(this.schiebetorTranslationsPunkt, this)
    );
    const gehflügelIndex = this.isGehflügelLinks ? 1 : 0;
    let x = 0;
    this.getFlügelSizesV3().forEach((size, index) => {
      const flügel = flügelPool.next();
      flügel.size.copy(size);
      flügel.hasKloben = this.isTor;
      flügel.hasAnschlagwinkel = this.isTor && !this.isDoppeltor;
      flügel.hasSchloss =
        (this.isDoppeltor ? index === gehflügelIndex : this.isTor) &&
        this.drückerAuswahlwert?.Key != "Drücker_Ohne";
      flügel.isÖffnungNachInnen = this.isÖffnungNachInnen;
      flügel.isAufhängungAnLinkerTorseite = this.isDoppeltor
        ? index === 0
        : this.isAufhängungAnLinkerTorseite;
      flügel.seiteGewechselt =
        (this.isDoppeltor
          ? index === 0
            ? !this.isÖffnungNachInnen
            : this.isÖffnungNachInnen
          : true) == this.seiteGewechselt;
      const isStandflügel = this.isDoppeltor ? index !== gehflügelIndex : false;
      flügel.hasTorschließer =
        !isStandflügel &&
        this.isTorschließerMöglich &&
        this.torschließerAuswahlwert?.Key === "Torschließer_mit";
      const [zu, halb, ganz] =
        Math.abs(this.torÖffnungswinkel) < 1
          ? [true, false, false]
          : Math.abs(this.torÖffnungswinkel) < 45
            ? [false, true, false]
            : [false, false, true];
      flügel.öffnungsWinkel = this.isTor
        ? this.isSchiebetor
          ? 0
          : (this.isDoppeltor
              ? (index === 0 ? 1 : -1) * (!isStandflügel || ganz ? 1 : 0)
              : this.isAufhängungAnLinkerTorseite
                ? 1
                : -1) *
            (this.isÖffnungNachInnen ? 1 : -1) *
            _.minBy(
              [
                0,
                clampTorÖffnungswinkelFürMauer(this, this.öffnungswinkel.x),
                clampTorÖffnungswinkelFürMauer(this, this.öffnungswinkel.y),
              ],
              (w) => Math.abs(this.torÖffnungswinkel - w)
            )
        : 0;
      flügel.transitionDelay = this.isDoppeltor
        ? zu
          ? isStandflügel
            ? 0
            : 1000
          : halb
            ? 0
            : /*ganz*/ isStandflügel
              ? 1000
              : 0
        : 0;
      flügel.transitionDuration = halb ? 300 : 1000;
      flügel.position.x = x;
      flügel.position.y = 0;
      x += flügel.size.x + APP.settings.doppeltorFlügelabstand;
      flügel.update3d();
      // die Drehachse des Flügels wird im Flügel erstellt und ist von den Kloben abhängig.
      // die Kloben richten sich nach den Pfosten.
    });
    flügelPool.cleanup();
  }

  updateFlügelSchiebetor() {
    const flügelPool = this.lazyPool(
      this.flügel,
      () => new Flügel(this.schiebetorTranslationsPunkt, this)
    );
    const gehflügelIndex = this.isGehflügelLinks ? 1 : 0;
    let x = 0;
    (this.schiebetorRahmenDef?.füllungsFenster ?? []).forEach((box, index) => {
      const flügel = flügelPool.next();
      const size = Maths3.v2To3xy(box.getSize(v2()), 0);
      flügel.size.copy(size);
      flügel.hasKloben = false;
      flügel.hasAnschlagwinkel = false;
      flügel.hasSchloss = false;
      flügel.isÖffnungNachInnen = this.isÖffnungNachInnen;
      flügel.isAufhängungAnLinkerTorseite = false;
      flügel.seiteGewechselt = this.seiteGewechselt;
      flügel.öffnungsWinkel = 0;
      flügel.transitionDelay = 0;
      flügel.transitionDuration = 0;
      flügel.position.x = box.min.x;
      flügel.position.y = box.min.y;
      flügel.update3d();
    });
    flügelPool.cleanup();
  }

  get schiebetorZOffset() {
    const a = this.schiebetormotorseiteAuswahlwert?.Key == "Schiebetormotorseite_A";
    return this.isSchiebetor ? 0.09 * (a ? -1 : +1) : 0;
  }

  get schiebetorZOffsetPfosten() {
    const a = this.schiebetormotorseiteAuswahlwert?.Key == "Schiebetormotorseite_A";
    return this.isSchiebetor ? 0.12 * (a ? -1 : +1) : 0;
  }

  getKloben() {
    return _.flatten(
      this.flügel
        ?.filter((f) => f.hasKloben)
        .map((f) => f?.torteile?.filter((t) => (t as any).isKloben))
    );
  }

  getAnschlagWinkel() {
    return this.flügel
      ?.find((f) => f.hasAnschlagwinkel)
      ?.torteile?.find((t) => (t as any).isAnschlagWinkel);
  }

  reset() {
    super.reset();
    // das hier müssen exakt die persistierten oder session Werte sein!
    this.füllungAuswahlwert = null;
    this.füllungAuswahlwertIndividualisiert = false;
    this.rahmenAuswahlwert = null;
    // fixme das hier stimmt ja nicht so ganz. Teilweise existieren dazu Defaults in der  Arrangement - Klasse. Diese sollten auch genommen werden! Oder weg damit..
    this.gehflügelAuswahlwert =
      APP.richMetadata.getAuswahlWertVoreinstellungOrFirstForKey("Gehflügel");
    this.drückerAuswahlwert = APP.richMetadata.getAuswahlWertVoreinstellungOrFirstForKey("Drücker");
    this.profilzylinderAuswahlwert =
      APP.richMetadata.getAuswahlWertVoreinstellungOrFirstForKey("Profilzylinder");
    this.öffnungAuswahlwert = APP.richMetadata.getAuswahlWertVoreinstellungOrFirstForKey("Öffnung");
    this.anschlagAuswahlwert =
      APP.richMetadata.getAuswahlWertVoreinstellungOrFirstForKey("Anschlag");
    this.schieberichtungAuswahlwert =
      APP.richMetadata.getAuswahlWertVoreinstellungOrFirstForKey("Schieberichtung");
    this.schiebetormotorseiteAuswahlwert =
      APP.richMetadata.getAuswahlWertVoreinstellungOrFirstForKey("Schiebetormotorseite");
    this.füllungsseiteAuswahlwert =
      APP.richMetadata.getAuswahlWertVoreinstellungOrFirstForKey("Füllungsseite");
    this.anschlagprofilAuswahlwert =
      APP.richMetadata.getAuswahlWertVoreinstellungOrFirstForKey("Anschlagprofil");
    this.anschlagprofilfarbeAuswahlwert =
      APP.richMetadata.getAuswahlWertVoreinstellungOrFirstForKey("Anschlagprofilfarbe");
    this.abschlussleisteAuswahlwert =
      APP.richMetadata.getAuswahlWertVoreinstellungForKey("Profilleiste");
    this.abschlussleisteAuswahlwertIndividualisiert = false;
    this.profilKategorieAuswahlwert =
      APP.richMetadata.getAuswahlWertVoreinstellungForKey("Profilkategorie");
    this.profilleisteAuswahlwert =
      APP.richMetadata.getAuswahlWertVoreinstellungForKey("Profilleiste");
    this.eAntriebAuswahlwert =
      APP.richMetadata.getAuswahlWertVoreinstellungForKey("E_Antrieb_Vorhanden");
    this.zubehörAnzahl = {
      ...APP.richMetadata.getDefaultAnzahlForEAntriebZubehör(),
    } as ZubehörAnzahl;
    this.aufsatzleisteAuswahlwert =
      APP.richMetadata.getAuswahlWertVoreinstellungForKey("Aufsatzleiste");
    this.massAuswahlwert = APP.richMetadata.getAuswahlWertVoreinstellungForKey("EasyMass");
    this.toröffnerAuswahlwert =
      APP.richMetadata.getAuswahlWertVoreinstellungOrFirstForKey("Toröffner");
    this.torschließerAuswahlwert =
      APP.richMetadata.getAuswahlWertVoreinstellungOrFirstForKey("Torschließer");
    this.form = null;
    this.profilAuswahlwert = null;
    this.profilAuswahlwertIndividualisiert = false;
    this.profilPosition = null;
    this.profilPositionIndividualisiert = false;
    this.showProfil = null;
    this.size?.set(0, 0, 0);
    this.anschlussAufRechts = false;
    this.seiteGewechselt = false;
    this.gehflügelbreite = 0;
    this.standflügelbreite = 0;
    this.torÖffnungswinkel = 10;
    this.torIstFertig = false;
  }

  clone(): ZElement {
    const clone = new ZElement(undefined);
    clone.copy(this);
    return clone;
  }

  copy(element: ZElement) {
    super.copy(element);
    // das hier müssen exakt die persistierten oder session Werte sein!
    this.füllungAuswahlwert = element.füllungAuswahlwert;
    this.füllungAuswahlwertIndividualisiert = element.füllungAuswahlwertIndividualisiert;
    this.gehflügelAuswahlwert = element.gehflügelAuswahlwert;
    this.drückerAuswahlwert = element.drückerAuswahlwert;
    this.profilzylinderAuswahlwert = element.profilzylinderAuswahlwert;
    this.rahmenAuswahlwert = element.rahmenAuswahlwert;
    this.öffnungAuswahlwert = element.öffnungAuswahlwert;
    this.anschlagAuswahlwert = element.anschlagAuswahlwert;
    this.schieberichtungAuswahlwert = element.schieberichtungAuswahlwert;
    this.schiebetormotorseiteAuswahlwert = element.schiebetormotorseiteAuswahlwert;
    this.füllungsseiteAuswahlwert = element.füllungsseiteAuswahlwert;
    this.anschlagprofilAuswahlwert = element.anschlagprofilAuswahlwert;
    this.anschlagprofilfarbeAuswahlwert = element.anschlagprofilfarbeAuswahlwert;
    this.abschlussleisteAuswahlwert = element.abschlussleisteAuswahlwert;
    this.abschlussleisteAuswahlwertIndividualisiert =
      element.abschlussleisteAuswahlwertIndividualisiert;
    this.profilKategorieAuswahlwert = element.profilKategorieAuswahlwert;
    this.profilAuswahlwert = element.profilAuswahlwert;
    this.profilAuswahlwertIndividualisiert = element.profilAuswahlwertIndividualisiert;
    this.profilleisteAuswahlwert = element.profilleisteAuswahlwert;
    this.eAntriebAuswahlwert = element.eAntriebAuswahlwert;
    this.zubehörAnzahl = normalizeZubehörAnzahl(element.zubehörAnzahl, this.zubehörAnzahl);
    this.aufsatzleisteAuswahlwert = element.aufsatzleisteAuswahlwert;
    this.toröffnerAuswahlwert = element.toröffnerAuswahlwert;
    this.torschließerAuswahlwert = element.torschließerAuswahlwert;
    this.form = element.form;
    this.profilPosition = element.profilPosition;
    this.profilPositionIndividualisiert = element.profilPositionIndividualisiert;
    this.showProfil = element.showProfil;
    this.size.copy(element.size);
    this.anschlussAufRechts = element.anschlussAufRechts;
    this.gehflügelbreite = element.gehflügelbreite;
    this.standflügelbreite = element.standflügelbreite;
    this.torÖffnungswinkel = element.torÖffnungswinkel;
    this.torIstFertig = element.torIstFertig;
    this.isStandardMass = element.isStandardMass;
    // zusätzlich solche, die geccloned werden müssen
    this.meta = element.meta;
    this.füllungMeta = element.füllungMeta;
    this.rahmenMeta = element.rahmenMeta;
    this.massMetas = element.massMetas;
    this.massAuswahlwert = element.massAuswahlwert;
    this.isStandardMass = element.isStandardMass;
    this.sizeRange.Schrittweite.copy(element.sizeRange.Schrittweite);
    this.sizeRange.box.copy(element.sizeRange.box);
    this.sizeRange.flügelBox.copy(element.sizeRange.flügelBox);
    return this;
  }

  createJaco3d() {
    return new Element3d(this);
  }

  getBox(): Box3 {
    const box = Maths3.boxFromGridMinAndSize(v3(0, 0, 0.5), this.size);
    const az = this.meta?.Mass.AbmessungZ || v2();
    box.min.z = az.x;
    box.max.z = az.y;
    return box;
  }

  async getRenderPromise() {
    this.update3d();
    const promises = [this.füllungMeta, this.rahmenMeta]
      .map((x) => APP.modelsHelper.getRenderPromise(getMMR(x)))
      .filter((x) => x != null);
    if (promises.length == 0) {
      console.error("element has no renderPromise", this);
    }
    await Promise.all(promises);
    this.jaco3d.traverse((x: any) => x.update3d && x.update3d());
    return this.jaco3d;
  }

  /**
   * Name-Äquivalent für "Füllung". Betrifft Menüpunkt im Torkonfigurator und MassElementePdf
   */
  getFüllungName() {
    const showRahmen = !Commons.isEmpty(this.rahmenAuswahlwert);
    if (!showRahmen) return "Farbe";
    return this.isTor ? "Füllung" : isGlas(this.meta) ? "Design" : "Farbe";
  }

  isHideRahmen() {
    const elementAuswahlAccessoren = filterElementAuswahlAccessorenForMany([this]);
    const rahmenAuswahlwerte = elementAuswahlAccessoren.Rahmen.möglicheAuswahlwerte;
    return rahmenAuswahlwerte.length < 2;
  }

  toJSON(): any {
    const json = super.toJSON();
    // das hier müssen exakt die persistierten Werte sein!
    json.füllungAuswahlwert = this.füllungAuswahlwert?.Key;
    json.füllungAuswahlwertIndividualisiert = this.füllungAuswahlwertIndividualisiert;
    json.gehflügelAuswahlwert = this.gehflügelAuswahlwert?.Key;
    json.drückerAuswahlwert = this.drückerAuswahlwert?.Key;
    json.profilzylinderAuswahlwert = this.profilzylinderAuswahlwert?.Key;
    json.rahmenAuswahlwert = this.rahmenAuswahlwert?.Key;
    json.öffnungAuswahlwert = this.öffnungAuswahlwert?.Key;
    json.anschlagAuswahlwert = this.anschlagAuswahlwert?.Key;
    json.schieberichtungAuswahlwert = this.schieberichtungAuswahlwert?.Key;
    json.schiebetormotorseiteAuswahlwert = this.schiebetormotorseiteAuswahlwert?.Key;
    json.füllungsseiteAuswahlwert = this.füllungsseiteAuswahlwert?.Key;
    json.anschlagprofilAuswahlwert = this.anschlagprofilAuswahlwert?.Key;
    json.anschlagprofilfarbeAuswahlwert = this.anschlagprofilfarbeAuswahlwert?.Key;
    json.abschlussleisteAuswahlwert = this.abschlussleisteAuswahlwert?.Key;
    json.abschlussleisteAuswahlwertIndividualisiert =
      this.abschlussleisteAuswahlwertIndividualisiert;
    json.profilKategorieAuswahlwert = this.profilKategorieAuswahlwert?.Key;
    json.profilAuswahlwert = this.profilAuswahlwert?.Key;
    json.profilAuswahlwertIndividualisiert = this.profilAuswahlwertIndividualisiert;
    json.profilleisteAuswahlwert = this.profilleisteAuswahlwert?.Key;
    json.eAntriebAuswahlwert = this.eAntriebAuswahlwert?.Key;
    json.zubehörAnzahl = this.zubehörAnzahl;
    // Legacy fields for compatibility with older imports/exports.
    json.aufsatzleisteAuswahlwert = this.aufsatzleisteAuswahlwert?.Key;
    json.toröffnerAuswahlwert = this.toröffnerAuswahlwert?.Key;
    json.torschließerAuswahlwert = this.torschließerAuswahlwert?.Key;
    json.form = this.form?.Key;
    json.massAuswahlwert = this.massAuswahlwert?.Key;
    json.profilPosition = this.profilPosition;
    json.profilPositionKorrigiert =
      this.profilPosition != null && this.profilPosition !== "center"
        ? this.profilPosition - this.getWegschneidenHöheUnterstesProfil().profilPositionDelta
        : this.profilPosition;
    json.profilPositionIndividualisiert = this.profilPositionIndividualisiert;
    json.showProfil = this.showProfil;
    json.anschlussAufRechts = this.anschlussAufRechts;
    json.gehflügelbreite = this.gehflügelbreite;
    json.standflügelbreite = this.standflügelbreite;
    json.torIstFertig = this.torIstFertig;
    // zusätzlich noch ein paar Werte, die eigentlich nicht notwendig sind, aber nützlich sein könnten für weitere Verarbeitung
    json.elementNr = this.elementNr;
    json.isStandardMass = this.isStandardMass;
    json.detailSerie = this.meta?.DetailSerie?.[0]?.Key;
    json.anMauer = this.anMauerLinksRechtsOderBeide;
    json.isMasstor = this.isMasstor;
    json.isMasselement = this.isMasselement;
    json.isMassProfil = this.isMassProfil;
    json.isBestellseite = this.isBestellseite;
    json.isEAntrieb = this.isEAntrieb;

    // Zusätzliche Werte für die Bestellseiten:
    if (json.isMasstor || json.isMasselement || json.isMassProfil || json.isBestellseite) {
      json.key = this.meta.Key;
      json.höhe = Maths.round(this.höhe, JSON_DECIMALS);
      json.breite = Maths.round(this.size.x, JSON_DECIMALS);
      json.lichteWeite = Maths.round(this.lichteWeite, JSON_DECIMALS);
      json.dreifachtorPositionEinzeltor = this.dreifachtorPositionEinzeltor?.Key;
      json.einsteckschlossAuswahlwert = _.first(this.meta.Einsteckschloss)?.Key;
      json.beschlagsatzAuswahlwert = this.getBeschlagsatzFürTor(
        this.getPfosten()[this.isAufhängungAnLinkerTorseite ? 0 : 1]
      )?.Key;
      json.hideRahmen = json.rahmenAuswahlwert == null || this.isHideRahmen();
      json.showProfilausrichtung = this.meta.DetailSerie?.[0].Senkrechtverbau;
      json.showAdapterleiste =
        (this.getLeisten().dekorprofilleisteUnten ?? this.getLeisten().dekorprofilleisteOben) !==
        null;
      json.hasAnschlagprofil = this.hasAnschlagprofil;
      json.bestelllisteArtikel = this.bestellliste
        .filter((x) => x.Gruppe == "Toraufhängung")
        .map((x) => x.ArtikelID);

      if (json.isMassProfil)
        json.artikelID = _.first(this.profilMeta.Artikelrelation)?.Artikel?.ArtikelID;
      else json.artikelID = _.first(this.meta.Artikelrelation)?.Artikel?.ArtikelID;

      json.füllungName = this.getFüllungName();
      json.ausrichtungCode = ausrichtungCode(this);
      json.profilAnzahl = (
        this.profilKategorieAuswahlwert?.Profilkategorie?.[0] ?? this.sonderprofilKategorie
      )?.ProfilAnzahl;
      json.pdf = {};
    }

    if (this.isSchiebetor) {
      json.schiebetorRahmenDef = Commons.cloneDeep(this.schiebetorRahmenDef);
    }

    json.elementID = this.elementID;

    return json;
  }

  fromJSON(json: any = {}) {
    super.fromJSON(json);
    // das hier müssen exakt die persistierten Werte sein!
    this.füllungAuswahlwert = APP.richMetadata.findAuswahlwertOrDefault(
      json.füllungAuswahlwert,
      "Füllung"
    );
    this.füllungAuswahlwertIndividualisiert = json.füllungAuswahlwertIndividualisiert ?? false;
    this.gehflügelAuswahlwert = APP.richMetadata.findAuswahlwertOrDefaultOrFirst(
      json.gehflügelAuswahlwert,
      "Gehflügel"
    );
    this.drückerAuswahlwert = APP.richMetadata.findAuswahlwertOrDefaultOrFirst(
      json.drückerAuswahlwert,
      "Drücker"
    );
    this.profilzylinderAuswahlwert = APP.richMetadata.findAuswahlwertOrDefaultOrFirst(
      json.profilzylinderAuswahlwert,
      "Profilzylinder"
    );
    this.rahmenAuswahlwert = APP.richMetadata.findAuswahlwertOrDefault(
      json.rahmenAuswahlwert,
      "Rahmen"
    );
    this.öffnungAuswahlwert = APP.richMetadata.findAuswahlwertOrDefaultOrFirst(
      json.öffnungAuswahlwert,
      "Öffnung"
    );
    this.anschlagAuswahlwert = APP.richMetadata.findAuswahlwertOrDefaultOrFirst(
      json.anschlagAuswahlwert,
      "Anschlag"
    );
    this.schieberichtungAuswahlwert = APP.richMetadata.findAuswahlwertOrDefaultOrFirst(
      json.schieberichtungAuswahlwert,
      "Schieberichtung"
    );
    this.schiebetormotorseiteAuswahlwert = APP.richMetadata.findAuswahlwertOrDefaultOrFirst(
      json.schiebetormotorseiteAuswahlwert,
      "Schiebetormotorseite"
    );
    this.füllungsseiteAuswahlwert = APP.richMetadata.findAuswahlwertOrDefaultOrFirst(
      json.füllungsseiteAuswahlwert,
      "Füllungsseite"
    );
    this.anschlagprofilAuswahlwert = APP.richMetadata.findAuswahlwertOrDefaultOrFirst(
      json.anschlagprofilAuswahlwert,
      "Anschlagprofil"
    );
    this.anschlagprofilfarbeAuswahlwert = APP.richMetadata.findAuswahlwertOrDefaultOrFirst(
      json.anschlagprofilfarbeAuswahlwert,
      "Anschlagprofilfarbe"
    );
    this.abschlussleisteAuswahlwert = APP.richMetadata.findAuswahlwertOrDefault(
      json.abschlussleisteAuswahlwert,
      "AbschlussleisteOben"
    );
    this.abschlussleisteAuswahlwertIndividualisiert =
      json.abschlussleisteAuswahlwertIndividualisiert ?? false;
    this.profilKategorieAuswahlwert = APP.richMetadata.findAuswahlwertOrDefault(
      json.profilKategorieAuswahlwert,
      "Profilkategorie"
    );
    this.profilAuswahlwert = APP.richMetadata.findAuswahlwert(json.profilAuswahlwert);
    this.profilAuswahlwertIndividualisiert = json.profilAuswahlwertIndividualisiert ?? false;
    this.profilleisteAuswahlwert = APP.richMetadata.findAuswahlwertOrDefault(
      json.profilleisteAuswahlwert,
      "Profilleiste"
    );
    this.eAntriebAuswahlwert = APP.richMetadata.findAuswahlwertOrDefault(
      json.eAntriebAuswahlwert,
      "E_Antrieb_Vorhanden"
    );
    this.zubehörAnzahl = normalizeZubehörAnzahl(json.zubehörAnzahl, {
      ...APP.richMetadata.getDefaultAnzahlForEAntriebZubehör(),
    });
    this.aufsatzleisteAuswahlwert = APP.richMetadata.findAuswahlwertOrDefault(
      json.aufsatzleisteAuswahlwert,
      "Aufsatzleiste"
    );
    this.massAuswahlwert = APP.richMetadata.findAuswahlwertOrDefault(
      json.massAuswahlwert,
      "EasyMass"
    );
    this.form = APP.richMetadata.findEnsureAnyObjekt(json.form);
    this.toröffnerAuswahlwert = APP.richMetadata.findAuswahlwertOrDefaultOrFirst(
      json.toröffnerAuswahlwert,
      "Toröffner"
    );
    this.torschließerAuswahlwert = APP.richMetadata.findAuswahlwertOrDefaultOrFirst(
      json.torschließerAuswahlwert,
      "Torschließer"
    );
    this.profilPosition = json.profilPosition;
    this.profilPositionIndividualisiert = json.profilPositionIndividualisiert ?? false;
    this.showProfil = json.showProfil;
    this.anschlussAufRechts = json.anschlussAufRechts;
    this.gehflügelbreite = json.gehflügelbreite;
    this.standflügelbreite = json.standflügelbreite;
    this.torIstFertig = json.torIstFertig;
    // Abwärtskompatibilität -----------------------
    if (json.size) {
      this.size.fromJSON(json.size);
    } else {
      this.size.x = this.breite;
      this.size.y = this.höhe;
    }
    this.elementID = json.elementID;
    return this;
  }

  isSame() {}

  /**
   * für Testzwecke: serialisiert zu und nach json, wobei ein Teil der Werte überschrieben werden können
   */
  setJsonPartial(partialJson = {}) {
    this.fromJSON({ ...this.toJSON(), ...partialJson });
  }

  get isStandardHöhe() {
    return this.size.y == this.meta.Mass.Standard.y;
  }

  get isStandardBreite() {
    return this.size.x == this.meta.Mass.Standard.x;
  }

  get einzeltorNachbar() {
    return this.getSegmentNachbarn().find((e) => (e as ZElement)?.isEinzeltor);
  }

  get doppeltorNachbar() {
    return this.getSegmentNachbarn().find((e) => (e as ZElement)?.isDoppeltor);
  }

  get groupTagOwner() {
    return (this.isEinzeltor && this.doppeltorNachbar) || this;
  }

  get ObjectGroupTag() {
    const owner = this.groupTagOwner;
    return owner.getJaco3dName() + "_" + owner.id;
  }

  get MassOrBauseitsTagSelf() {
    const round = (x) => Math.round(x * 100);
    return this.isStandardMass || this.isSchiebetor
      ? ""
      : this.isBauseitskürzbaresElement
        ? "bauseits"
        : `${round(this.flügelsummenbreite)}\xa0x\xa0${round(this.size.y)}\xa0cm`; // \xa0 == NBSP
  }

  get MassOrBauseitsTag(): string {
    if (this.isDreifachtor && this.isDoppeltor) {
      return `${I18N("Dreifachtor")} ${this.MassOrBauseitsTagSelf} + ${(this.einzeltorNachbar as ZElement).MassOrBauseitsTagSelf}`; // Hier darf kein Doppelpunkt rein, da Stückliste.ts:mapArtikelGroupTagArtikelBagToBaugruppen sonst Mist baut
    }

    return this.groupTagOwner.MassOrBauseitsTagSelf;
  }

  getElementIndex() {
    return this.arrangement.getElemente().indexOf(this);
  }

  collectArtikel(iterator: StücklistenIterator) {
    const ObjectGroupTag = this.ObjectGroupTag;
    const JacoId = this.id;
    iterator({
      ObjectGroupTag,
      ElementIndex: this.getElementIndex(),
      JacoId,
      MassOrBauseitsTag: this.MassOrBauseitsTag,
      Variabel: this.groupTagOwner.Variabel,
    });

    if (
      !this.anschlussAufRechts == !this.seiteGewechselt &&
      this.isMultipleFüllungsseiten &&
      this.meta.ArtikelAnschlussRechts
    ) {
      iterator({
        Artikel: this.meta.ArtikelAnschlussRechts,
        Anzahl: 1,
        ObjectGroupTag,
        JacoId,
      });
    } else {
      iterator({
        ObjektMeta: this.meta,
        ObjectGroupTag,
        JacoId,
      });
    }
    this.flügel.forEach((flügel) => flügel.collectArtikel(iterator, ObjectGroupTag, JacoId));

    this.elementhalter.forEach((elementHalter) =>
      iterator({
        ObjektMeta: elementHalter.getMeta().Objekt,
        ObjectGroupTag,
        JacoId,
      })
    );

    const drücker = findPathIntersectionCached("Element.js:1138")(
      this.meta,
      (m: PTor) => m.Drücker,
      this.drückerAuswahlwert,
      (auswahlwert: PAuswahlwert) => auswahlwert.Objekt
    );
    drücker && iterator({ ObjektMeta: drücker, ObjectGroupTag, JacoId });

    const toröffner = findPathIntersectionCached("Element.js:1229")(
      this.meta,
      (m: PTor) => m.Toröffner,
      this.toröffnerAuswahlwert,
      (auswahlwert: PAuswahlwert) => auswahlwert.Objekt
    );
    toröffner && iterator({ ObjektMeta: toröffner, ObjectGroupTag, JacoId });

    const torschließer = findPathIntersectionCached("Element.js:1237")(
      this.meta,
      (m: PTor) => m.Torschließer,
      this.torschließerAuswahlwert,
      (auswahlwert: PAuswahlwert) => auswahlwert.Objekt
    );
    torschließer && iterator({ ObjektMeta: torschließer, ObjectGroupTag, JacoId });

    this.profilzylinderAuswahlwert?.Key == "Profilzylinder_mit" &&
      iterator({
        ObjektMeta: _.first((this.meta as MTor).Profilzylinder),
        ObjectGroupTag,
        JacoId,
      });

    !Commons.isEmpty((this.meta as MTor).Beschlagsatz) &&
      iterator({
        ObjektMeta: this.getBeschlagsatzFürTor(
          this.getPfosten()[this.isAufhängungAnLinkerTorseite ? 0 : 1]
        ),
        ObjectGroupTag,
        JacoId,
      });

    !Commons.isEmpty((this.meta as MTor).Einsteckschloss) &&
      iterator({
        ObjektMeta: _.first((this.meta as MTor).Einsteckschloss),
        ObjectGroupTag,
        JacoId,
      });

    this.zubehörTeile.forEach(({ zubehör, anzahl }) =>
      iterator({
        ObjektMeta: zubehör,
        Anzahl: anzahl,
        ObjectGroupTag,
        JacoId,
      })
    );
  }

  getDeltaabstandmassRow() {
    return _.first(
      [this.pfostenLinks, this.pfostenRechts].map((p) =>
        APP.richMetadata.getDeltaabstandsmassRow(this.meta, p?.meta as MPfosten)
      )
    );
  }

  get serie() {
    return this.arrangement.serie;
  }

  get isTor() {
    return isTorFn(this.meta);
  }

  get isDoppeltor() {
    return isDoppeltorFn(this.meta);
  }

  get isSchiebetor() {
    return isSchiebetorForm(this.meta?.Mass?.Form);
  }

  get schiebetorExtrapunkte() {
    if (!this.isSchiebetor) return undefined;
    const segment = this.segment;
    const { torBreite, lichteWeite } = this.schiebetorRahmenDef;
    const [einzelpfosten, doppelpfosten, links, rechts, sign] = this.isAnschlagLinks
      ? [this.pfostenLinks, this.pfostenRechts, 0, 1, +1]
      : [this.pfostenRechts, this.pfostenLinks, 1, 0, -1];
    const einzelPfostenInnen_x = segment.getX(einzelpfosten, rechts);
    const doppelPfostenInnen_x = segment.getX(doppelpfosten, links);
    const doppelPfostenAussen_x = segment.getX(doppelpfosten, rechts);
    const torSpitzeWennGeschlossen_x = einzelPfostenInnen_x + torBreite * sign;
    const torSpitzeWennOffen_x = einzelPfostenInnen_x + (lichteWeite + torBreite) * sign;
    return {
      einzelPfostenInnen_x,
      doppelPfostenInnen_x,
      doppelPfostenAussen_x,
      torSpitzeWennGeschlossen_x,
      torSpitzeWennOffen_x,
    };
  }

  getSchiebetorOffenBox() {
    if (!this.isSchiebetor) return undefined;
    const { einzelPfostenInnen_x, torSpitzeWennOffen_x } = this.schiebetorExtrapunkte;
    const puffer = APP.settings.SchiebetorPuffer ?? 0.2;
    const z = this.schiebetorZOffset;
    const b = this.getBox();
    const size = b.getSize(v3());
    b.min.y = 0;
    b.max.y = this.höhe;
    b.min.x = Math.min(einzelPfostenInnen_x, torSpitzeWennOffen_x);
    b.max.x = Math.max(einzelPfostenInnen_x, torSpitzeWennOffen_x);
    // Puffer in Öffnungsrichtung hinzufügen
    if (torSpitzeWennOffen_x > einzelPfostenInnen_x) {
      b.max.x += puffer;
    } else {
      b.min.x -= puffer;
    }
    b.min.z = z - size.z / 2;
    b.max.z = z + size.z / 2;
    return b;
  }

  getFlügelÖffnungsbereichZylinderSektoren(
    maxOpenAngleDeg = clampTorÖffnungswinkelFürMauer(this, this.öffnungswinkel.y)
  ): FlügelÖffnungsbereichZylinderSektor[] {
    if (!this.isTor || this.isSchiebetor || this.flügel.length == 0) {
      return [];
    }

    const normalizeAngle = (angle: number) => {
      let a = angle % (Math.PI * 2);
      if (a < 0) a += Math.PI * 2;
      return a;
    };
    const angle = (Math.PI / 180) * Math.abs(maxOpenAngleDeg);

    return this.flügel.map((flügel) => {
      const { localBox, pivot } = this.getFlügelLokaleSweepBoxUndPivot(flügel);

      const fallbackDirection =
        (flügel.isAufhängungAnLinkerTorseite ? 1 : -1) * (flügel.isÖffnungNachInnen ? 1 : -1);
      const direction = -(Math.sign(flügel.öffnungsWinkel || fallbackDirection) || 1);
      const targetAngle = direction * angle;

      const xValues = [localBox.min.x, localBox.max.x];
      const zValues = [localBox.min.z, localBox.max.z];
      const cornerRadii: number[] = [];

      xValues.forEach((x) => {
        zValues.forEach((z) => {
          const dx = x - pivot.x;
          const dz = z - pivot.z;
          cornerRadii.push(Math.hypot(dx, dz));
        });
      });

      const boxCenter = localBox.getCenter(v3());
      const freierRandX = flügel.isAufhängungAnLinkerTorseite ? localBox.max.x : localBox.min.x;
      const closedAngle = Math.atan2(boxCenter.z - pivot.z, freierRandX - pivot.x);
      const startAngle =
        targetAngle >= 0 ? normalizeAngle(closedAngle) : normalizeAngle(closedAngle + targetAngle);
      const endAngle =
        targetAngle >= 0 ? normalizeAngle(closedAngle + targetAngle) : normalizeAngle(closedAngle);

      return {
        isAufhängungAnLinkerTorseite: flügel.isAufhängungAnLinkerTorseite,
        pivot: pivot.clone(),
        radiusInner: Math.max(0, Math.min(...cornerRadii)),
        radiusOuter: Math.max(...cornerRadii),
        yMin: localBox.min.y,
        yMax: localBox.max.y,
        startAngle,
        endAngle,
      };
    });
  }

  getFlügelÖffnungsbereichWarnSektoren(): FlügelÖffnungsbereichZylinderSektor[] {
    const normalizeAngle = (angle: number) => {
      let a = angle % (Math.PI * 2);
      if (a < 0) a += Math.PI * 2;
      return a;
    };
    const sektorToWorld = (sektor: FlügelÖffnungsbereichZylinderSektor) => {
      const matrixWorld = this.segment.matrixWorld;
      const pivot = sektor.pivot.clone().applyMatrix4(matrixWorld);
      const pStart = v3(
        sektor.pivot.x + Math.cos(sektor.startAngle),
        sektor.pivot.y,
        sektor.pivot.z + Math.sin(sektor.startAngle)
      ).applyMatrix4(matrixWorld);
      const pEnd = v3(
        sektor.pivot.x + Math.cos(sektor.endAngle),
        sektor.pivot.y,
        sektor.pivot.z + Math.sin(sektor.endAngle)
      ).applyMatrix4(matrixWorld);
      const yPointMin = v3(sektor.pivot.x, sektor.yMin, sektor.pivot.z).applyMatrix4(matrixWorld);
      const yPointMax = v3(sektor.pivot.x, sektor.yMax, sektor.pivot.z).applyMatrix4(matrixWorld);

      return {
        ...sektor,
        pivot,
        yMin: Math.min(yPointMin.y, yPointMax.y),
        yMax: Math.max(yPointMin.y, yPointMax.y),
        startAngle: normalizeAngle(Math.atan2(pStart.z - pivot.z, pStart.x - pivot.x)),
        endAngle: normalizeAngle(Math.atan2(pEnd.z - pivot.z, pEnd.x - pivot.x)),
      };
    };

    return this.getFlügelÖffnungsbereichZylinderSektoren().map(sektorToWorld);
  }

  private getFlügelLokaleSweepBoxUndPivot(flügel: Flügel): { localBox: Box3; pivot: Vector3 } {
    const pfosten = flügel.isAufhängungAnLinkerTorseite ? this.pfostenLinks : this.pfostenRechts;
    const xf = flügel.isAufhängungAnLinkerTorseite ? -1 : 1;
    const zf = flügel.isÖffnungNachInnen ? -1 : 1;
    const klobenPivotYOffset = 0.04;
    const klobenPivotXOffset = pfosten?.anMauer ? -0.0194 * xf : 0.055 * xf;
    const klobenPivotZOffset = pfosten?.anMauer ? 0.099 * zf : 0.06 * zf;

    const localBox = flügel.getBox().clone().translate(flügel.position).translate(this.position);
    const boxCenter = localBox.getCenter(v3());
    const pivot = v3(
      this.position.x +
        flügel.position.x +
        (flügel.isAufhängungAnLinkerTorseite ? 0 : flügel.size.x) +
        klobenPivotXOffset,
      this.position.y + flügel.position.y + klobenPivotYOffset,
      boxCenter.z + klobenPivotZOffset
    );
    return { localBox, pivot };
  }

  get isEinzeltor() {
    return this.isTor && !this.isDoppeltor && !this.isSchiebetor;
  }

  get isDreifachtor() {
    if (!this.nachbarLinks && !this.nachbarRechts) {
      return;
    }

    return (
      (this.isEinzeltor && this.getSegmentNachbarn().some((e) => (e as ZElement)?.isDoppeltor)) ||
      (this.isDoppeltor && this.getSegmentNachbarn().some((e) => (e as ZElement)?.isEinzeltor))
    );
  }

  get dreifachtorPositionEinzeltor() {
    if (!this.isDreifachtor || !this.isEinzeltor) return null;
    const partLinks = this.getPartAtRelativeIndex(this.isÖffnungNachInnen ? 1 : -1);
    const positionEinzeltorAuswahlwertKey = (partLinks as ZElement)?.isDoppeltor
      ? "Einzeltor_3fach_rechts"
      : "Einzeltor_3fach_links";
    return APP.richMetadata.findAuswahlwert(positionEinzeltorAuswahlwertKey);
  }

  get typname() {
    return this.isTor
      ? this.isDreifachtor
        ? "Dreifachtor"
        : this.isDoppeltor
          ? "Doppeltor"
          : "Einzeltor"
      : "Element";
  }

  get isMasstor() {
    return (this.meta as MTor)?.Masstor;
  }

  get isMasselement() {
    return !this.isTor && !this.isStandardMass && !this.isBauseitskürzbaresElement;
  }

  get isBestellseite() {
    return this.meta.Bestellseite;
  }

  get elementNr() {
    return APP.arrangement.getElemente().indexOf(this);
  }

  get lichteWeite() {
    const unechterPfostenZurLichtenweiteBreite = _.sum(
      this.getPfosten()
        .filter((p) => p != null && (p.isMontageplatten || p.isAnschlagprofil))
        .map((p) => p.breite)
    );
    const anschlagprofilAnSchiebetorpfostenBreite =
      this.getPfosten().some((p) => this.isEinzeltor && p?.isSchiebetorpfosten) &&
      this.anschlagprofilAuswahlwert?.UMProfil?.[0].Standard.x;

    return (
      this.size.x +
      this.gapLinks +
      this.gapRechts +
      unechterPfostenZurLichtenweiteBreite +
      anschlagprofilAnSchiebetorpfostenBreite
    );
  }

  get isAnschluss() {
    return this.meta?.Mass?.Form?.Key == "Anschluss";
  }

  get isMultipleFüllungsseiten() {
    return this.meta.Füllungsseite.length > 1;
  }

  get isFüllungsseiteInvertiert() {
    return this.meta.FüllungsseiteInvertiert;
  }

  get isAnschlussMitABLupe() {
    return (
      this.isAnschluss && this.meta.Aufbautyp.Key != "Profile" && this.isMultipleFüllungsseiten
    );
  }

  get seiteGewechselt() {
    if (this.isSchiebetor) {
      const seiteA = this.füllungsseiteAuswahlwert?.Key == "Füllungsseite_A";
      return this.isSchiebetorMotorseiteA == seiteA;
    }
    let seiteGewechselt =
      (this.füllungsseiteAuswahlwert?.Key == "Füllungsseite_A") == this.isÖffnungNachInnen;
    return seiteGewechselt;
  }

  set seiteGewechselt(v) {
    const öffnung = this.isÖffnungNachInnen;
    this.füllungsseiteAuswahlwert = APP.richMetadata.findEnsureAuswahlwert(
      v == öffnung ? "Füllungsseite_A" : "Füllungsseite_B"
    );
  }

  get isÖffnungNachInnen() {
    let öffnungNachInnen = this.öffnungAuswahlwert?.Key == "Öffnung_nach_innen";
    if (this.segment?.flippedNormal) {
      öffnungNachInnen = !öffnungNachInnen;
    }
    return öffnungNachInnen;
  }

  get öffnungswinkel() {
    return (this.meta as MTor).Öffnungswinkel;
  }

  get isAnschlagLinks() {
    if (this.isSchiebetor) {
      const l = this.schieberichtungAuswahlwert?.Key == "Schieberichtung_links";
      const a = this.schiebetormotorseiteAuswahlwert?.Key == "Schiebetormotorseite_A";
      return a ? l : !l;
    }
    return this.anschlagAuswahlwert?.Key == "Anschlag_links";
  }

  /**
   * Gibt zurück, ob die lokalen Z-Koordinaten der Schiebetor-Teile NICHT gespiegelt werden müssen.
   * Berücksichtigt die y180-Rotation des schiebetorFixPunkt (bei !isAnschlagLinks), daher wird
   * die Schieberichtung (l) zurückgegeben statt der Motorseite (a): die Rotation kompensiert
   * den Unterschied. Für die Welt-Z-Position des fixPunkt selbst siehe schiebetorZOffset.
   */
  get isSchiebetorMotorseiteA() {
    return this.schieberichtungAuswahlwert?.Key == "Schieberichtung_links";
  }

  // siehe auch Kommentar beim anschlagAuswahlwert.
  // isAufhängungAnLinkerTorseite bezieht sich auf Links / Rechts im Sinne der Segmentrichtung, also kleinere x-Werte
  // links und größere rechts, und ist unabhängig von der Öffnungsrichtung des Tores.
  // Der Defaultwert ist false, weil der Defaultwert für AnschlagAuswahlwert "DIN Links" und der Öffnungsrichtung "nach innen" ist
  get isAufhängungAnLinkerTorseite() {
    // Bei Schiebetoren gibt es keine Öffnungsrichtung im Sinne eines Drehflügels. Welche Seite
    // Einzel-(Schloss-) bzw. Doppel-(Aufhängungs-)pfosten trägt, ergibt sich allein aus
    // Schieberichtung und Motorseite (isAnschlagLinks) – siehe schiebetorExtrapunkte, wo bei
    // isAnschlagLinks der Einzelpfosten links und der Doppelpfosten rechts sitzt. Die
    // Öffnungsrichtung (und ihre Spiegelung über segment.flippedNormal) darf hier NICHT
    // einfließen, sonst würden die Pfosten in gespiegelten Segmenten vertauscht.
    if (this.isSchiebetor) {
      return !this.isAnschlagLinks;
    }
    let isLinks = this.isAnschlagLinks;
    if (this.isÖffnungNachInnen) {
      isLinks = !isLinks;
    }
    return isLinks;
  }

  get isGehflügelLinks() {
    return this.isÖffnungNachInnen
      ? this.gehflügelAuswahlwert?.Key == "Gehflügel_links"
      : this.gehflügelAuswahlwert?.Key == "Gehflügel_rechts";
  }

  get isDreifachtorEinzeltorLinks() {
    return this.dreifachtorPositionEinzeltor?.Key == "Einzeltor_3fach_links";
  }

  get selected() {
    return this.arrangement.selectedObjects.includes(this);
  }

  get isBreiteVariabel() {
    const box = this.sizeRange.flügelBox;
    return box.max.x - box.min.x > 0.01;
  }

  get isBauseitskürzbaresElement() {
    return this.Variabel == "bauseits";
  }

  get Variabel() {
    return this.meta?.Mass?.Variabel;
  }

  get anMauer() {
    return this.getPfosten().some((p) => p?.anMauer);
  }

  // Für toMass Kompatibilität
  get anMauerLinksRechtsOderBeide() {
    const [links, rechts] = this.getPfosten().map((p) => p?.anMauer);
    return links && rechts
      ? "AnMauer_beide"
      : links
        ? "AnMauer_links"
        : rechts
          ? "AnMauer_rechts"
          : "AnMauer_nein";
  }

  getFlügelSizesV3() {
    // size.z ist erst bekannt, wenn die Flügel erstellt wurden
    return this.getFlügelSizesV2().map((v) => Maths3.v2To3xy(v, 0));
  }

  getFlügelSizesV2() {
    return this.isSchiebetor
      ? this.schiebetorRahmenDef.füllungsFenster.map((b) => b.getSize(v2()))
      : getFlügelSizesV2(this as any);
  }

  setFlügelBreite(breite, index) {
    if (this.isDoppeltor) {
      if (index === (this.isGehflügelLinks ? 1 : 0)) {
        this.standflügelbreite = breite;
      } else {
        this.gehflügelbreite = breite;
      }
      this.setSizeFromFlügelBreiten();
    } else {
      this.size.x = this.breite = breite;
    }
  }

  setSizeFromFlügelBreiten() {
    this.breite = this.size.x = getBreiteFromFlügelBreiten(this);
  }

  getPfosten() {
    return [this.pfostenLinks, this.pfostenRechts];
  }

  getWandmontagePlatten() {
    return this.getPfosten()?.filter((p) => (p?.meta as MUMProfil)?.Typ == "Montageplatten");
  }

  hasAufhängungAnPfosten(pfosten) {
    return hasAufhängungAnPfosten(
      this.meta,
      this.isAufhängungAnLinkerTorseite,
      this.pfostenLinks === pfosten ? LINKS : RECHTS
    );
  }

  hasSchlossAnPfosten(pfosten) {
    return hasSchlossAnPfosten(
      this.meta,
      this.isAufhängungAnLinkerTorseite,
      this.pfostenLinks === pfosten ? LINKS : RECHTS
    );
  }

  get hasAnschlagprofil() {
    return (
      this.isTor &&
      this.getPfosten().some(
        (p) => p?.isAnschlagprofil || (this.isEinzeltor && p?.isSchiebetorpfosten)
      )
    );
  }

  /**
   * damit bei Toren die Profil-Nuten auf derselben Höhe wie bei normalen Zaunelementen derselben Füllung sind
   */
  getWegschneidenHöheUnterstesProfil(): { offsetY: number; profilPositionDelta: number } {
    const NULL = { offsetY: 0, profilPositionDelta: 0 };
    if (!this.isTor) {
      return NULL;
    }
    const meineUnterKanteErstesProfil = positionYOf(this.meta) + this.getRahmenInnenabstand();
    const füllungElemente = this.meta.Füllung[0]?.Element;
    if (!füllungElemente) {
      return NULL;
    }
    const normalesElementMeta = füllungElemente.find(
      (e) =>
        e.Mass.Form.Key == "Rechteck" &&
        e.DetailSerie.some((f) => this.meta.DetailSerie.some((g) => g === f))
    );
    if (normalesElementMeta == null) {
      return NULL;
    }
    const abschlussleisteUntenHöhe = this.getProfilHöhe(
      normalesElementMeta?.AbschlussleisteUnten?.[0]
    );
    if (this.füllungMeta == null) {
      return NULL;
    }
    const profilHöhe = this.getProfilHöhe(this.füllungMeta);
    const unterKanteErstesProfilElement =
      positionYOf(normalesElementMeta) + abschlussleisteUntenHöhe;
    const delta = meineUnterKanteErstesProfil - unterKanteErstesProfilElement;
    const offsetY = Math.max(0, delta % profilHöhe);
    const profilPositionDelta = Math.floor(delta / profilHöhe);
    return { offsetY, profilPositionDelta };
  }

  getRahmenInnenabstand() {
    if (this.isSchiebetor) {
      return schiebetorMasse({ lichteWeite: 2, torHöhe: 1.8 }).rahmenBreite + 0.06;
    }
    return getMMR(this.rahmenMeta)?.Model?.Rahmeninnenabstand ?? 0;
  }

  getProfilHöhe(profil) {
    if (profil == null) {
      return 0;
    }
    const mmr = getMMR(profil);
    const modelSize = APP.modelsHelper.getBoundingBox(mmr).getSize(v3());
    return modelSize.y + mmr.Model.Profilabstand;
  }

  get heightPhysical() {
    return _.max(this.flügel.map((f) => f.heightPhysical));
  }

  get isEAntrieb() {
    return (this.meta as MTor).E_Antrieb_Vorhanden;
  }

  get isRhombusOderRhombusHolz() {
    return isRhombusOderRhombusHolz(this.meta);
  }

  get isRhombusNichtHolz() {
    return this.meta.DetailSerie.some((d) => d.Key == "SYSTEM RHOMBUS");
  }

  get isJumboWPC() {
    return this.meta.DetailSerie[0]?.Key === "JUMBO WPC";
  }

  get isGada() {
    return this.meta.DetailSerie[0]?.Key === "GADA";
  }

  get isArzago() {
    return this.meta.DetailSerie[0]?.Key === "ARZAGO";
  }

  get isKeramikXL() {
    return this.meta.DetailSerie[0]?.Key === "SYSTEM KERAMIK XL";
  }

  get isAros() {
    return this.meta.DetailSerie[0]?.Key === "AROS Vorgarten";
  }

  get anschlussDiagHeight() {
    return this.meta.Mass.DiagHeight !== 0 ? this.meta.Mass.DiagHeight : 0.9;
  }

  get aufsatzleisteOffset() {
    return this.meta.Mass.AufsatzleisteOffset || 0;
  }

  get isSeitenleiste() {
    return this.arrangement.isSeitenleiste;
  }

  getMassMinMaxBox2() {
    return this.sizeRange.box;
  }

  get flügelsummenbreite() {
    return _.sum(this.flügel.map((flügel) => flügel.size.x));
  }

  get eAntriebInfo() {
    if (!this.isEAntrieb) {
      return null;
    }
    return APP.richMetadata.getEAntriebInfo(this);
  }

  get eAntriebHinweis() {
    if (Commons.isEmpty(this.eAntriebInfo?.hinweis)) {
      return null;
    }
    return this.eAntriebInfo.hinweis;
  }

  get isMassProfil() {
    return (
      !this.isTor &&
      !this.profilMeta?.Zuschnittsoptimiert?.[0]?.Zuschnitt &&
      this.profilMeta?.Zuschnittsoptimiert?.[0]?.MaßFüllung &&
      (!this.isStandardBreite || (!this.isStandardHöhe && this.isSenkrechtprofile))
    );
  }

  get pfostenMitAufhängung() {
    return this.getPfosten().find((p) => this.hasAufhängungAnPfosten(p));
  }

  get isGehflügelAufhängungAnMauer() {
    const gehflügel = this.flügel[this.isGehflügelLinks ? 0 : 1];
    const pfosten = this.isDoppeltor
      ? gehflügel?.isAufhängungAnLinkerTorseite
        ? this.pfostenRechts
        : this.pfostenLinks
      : this.pfostenMitAufhängung;
    return pfosten?.anMauer;
  }

  get isTorschließerMöglich() {
    return isTorschließerMöglichFn(
      this.meta,
      this.isDoppeltor ? this.gehflügelbreite : this.flügelsummenbreite,
      this.isGehflügelAufhängungAnMauer
    );
  }

  get isToröffnerMöglich() {
    return isToröffnerMöglichFn(this.meta, this.isAnschlagprofil);
  }

  get isSenkrechtprofile() {
    return this.meta.Aufbautyp?.Key == "SystemSenkrechtprofile";
  }

  get hasLichtleisten() {
    return this.showProfil && this.profilAuswahlwert?.Typinfo === "Lichtleiste";
  }

  get anzahlLichtleisten() {
    return this.hasLichtleisten ? this.flügel.length : 0;
  }

  get hasDekorprofil() {
    return this.showProfil && this.profilAuswahlwert?.Typinfo !== "Lichtleiste";
  }

  get isElementhalter() {
    return !Commons.isEmpty(this.elementhalter);
  }

  get isEAntriebMöglich() {
    return isBreiteFlügelFürEAntrieb(this.getFlügelSizesV2());
  }

  get hasIndividualisierteAuswahlwerte() {
    const elementAuswahlwerte = [
      "füllungAuswahlwertIndividualisiert",
      "abschlussleisteAuswahlwertIndividualisiert",
      "profilAuswahlwertIndividualisiert",
      "profilPositionIndividualisiert",
    ];
    return elementAuswahlwerte.some((auswahlwert) => this[auswahlwert]);
  }

  get isAnschlagprofil() {
    return this.getPfosten().some((p) => p?.isAnschlagprofil);
  }

  get isOhneStücklistenpositionDekorprofil() {
    return (this.meta as MTor).OhneStücklistenpositionDekorprofil;
  }

  getMeta() {
    return this.meta;
  }

  getTorpfosten() {
    const torPfosten = this.getPfosten().filter((p) => p?.isTorpfosten);
    return this.isDreifachtor
      ? torPfosten.concat(
          this.getAdjacentTor()
            .getPfosten()
            .filter((p) => p?.isTorpfosten && !torPfosten.includes(p))
        )
      : torPfosten;
  }

  getAdjacentTor(): ZElement {
    if (!this.isDreifachtor) {
      return null;
    }
    return this.getSegmentNachbarn().find((e) => (e as ZElement)?.isTor) as ZElement;
  }

  getInspirationsBild() {
    return (
      this.bestellliste.find((artikel) => artikel.Inspirationsbild)?.Inspirationsbild ??
      findPathIntersection(
        this.füllungMeta,
        (m: PObjekt) => m.Auswahlwert.Inspiration.Inspiration.Auswahlbild
      )
    );
  }

  behalteLichteweite(setter: Function) {
    const lichteWeiteVorher = this.lichteWeite;
    setter();
    this.arrangement.update3d();
    const delta = lichteWeiteVorher - this.lichteWeite;
    this.setBreite(this.breite + delta);
    this.arrangement.update3d();
  }

  get elementLinks() {
    return getAngrenzendeTeile(this, Richtung.LINKS).element;
  }

  get elementRechts() {
    return getAngrenzendeTeile(this, Richtung.RECHTS).element;
  }

  get zubehörTeile() {
    const zubehörType = this.isEAntrieb
      ? "E_Antrieb_Zubehör"
      : this.isSchiebetor
        ? "Schiebetor_Zubehör"
        : null;

    if (zubehörType == null) {
      return [];
    }
    return APP.richMetadata.getZubehöre(zubehörType, this.zubehörAnzahl);
  }
}

function normalizeZubehörAnzahl(value: any, fallback: ZubehörAnzahl = {}): ZubehörAnzahl {
  if (!value || Array.isArray(value) || typeof value !== "object") {
    return { ...fallback };
  }
  return Object.fromEntries(
    Object.entries(value).map(([key, v]) => [key, typeof v === "number" ? v : Number(v) || 0])
  ) as ZubehörAnzahl;
}
